import { Control, FieldValues, Path } from 'react-hook-form';

import {
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';
import { Label } from '@/components/ui/label';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';
import { cn } from '@/lib/ui/utils';

type RadioOption = {
  label: string;
  value: string;
};

type FormRadioGroupProps<T extends FieldValues> = {
  name: Path<T>;
  control: Control<T>;
  options: RadioOption[];
  label?: string;
  className?: string;
};

export const FormRadioGroup = <T extends FieldValues>({
  name,
  control,
  options,
  label,
  className,
}: FormRadioGroupProps<T>) => {
  return (
    <FormField
      name={name}
      control={control}
      render={({ field }) => (
        <FormItem className={className}>
          {label && (
            <FormLabel htmlFor={name} className={cn('as-title-03 as-strong')}>
              {label}
            </FormLabel>
          )}
          <RadioGroup
            className="flex flex-row gap-4"
            value={field.value}
            onValueChange={field.onChange}
          >
            {options.map((option) => (
              <div key={option.value} className="flex items-center space-x-2">
                <RadioGroupItem
                  id={`${name}-${option.value}`}
                  value={option.value}
                />
                <Label htmlFor={`${name}-${option.value}`}>
                  {option.label}
                </Label>
              </div>
            ))}
          </RadioGroup>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
